module.exports = __webpack_public_path__ + "img/jordan-ifueko.22c9cda9.png";